import React, {Component} from 'react';

class AccessForbidden extends Component {

  render() {
    return (
      <div className='empty-state-container'>
          <i className="material-icons">do_not_disturb</i>
          <div>{this.props.message}</div>
      </div>
    );
  }
}


export default AccessForbidden;
